import React from 'react';

import LinksPageLayout
  from 'components/dashboard/links-content/links-layout/LinksPageLayout';
import LocationLinksPageContent
  from 'components/dashboard/location-links-content/LocationLinksPageContent';


const DashboardLocationLinksPage = () => (
  <LinksPageLayout activeLinksPage="location">
    <LocationLinksPageContent />
  </LinksPageLayout>
);

export default DashboardLocationLinksPage;
